import AppTheme from './theme/AppTheme';
import { Box } from '@mui/material';
import ErrorModal from './components/modals/error_modal';
import { fetchGlobalThreadsThunk } from './redux/thunks/email';
import { fetchUserDetailThunk } from './redux/thunks/index';
import HeaderComponent from './components/reusable/header';
import { IncomingCallModal } from './components/incoming_call_modal';
import LoaderPage from './components/loader';
import { replaceToggleState } from './redux/slices';
import { RouteChangeToastCleaner } from './route_toast_cleaner';
import { TwilioProvider } from './twilio/twilio_provider';
import { AppDispatch, RootState } from './redux/store';
import { Outlet, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const AppPage = (props: { disableCustomTheme?: boolean }): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { token, isSales, selectedToggles } = useSelector((state: RootState) => state.app);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchUserDetail = async () => {
    try {
      await dispatch(fetchUserDetailThunk()).unwrap();
      dispatch(fetchGlobalThreadsThunk()).unwrap();
    } catch (e) {
      //
    }
  };

  useEffect(() => {
    if (token) {
      fetchUserDetail();
    } else {
      navigate('/login');
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [token]);

  useEffect(() => {
    if (!selectedToggles) {
      dispatch(replaceToggleState([
        'dashboard',
        'task-files',
        'billing',
        'sales-marketing',
        'lead-management',
        'team-space',
        'customer-management',
        'review-management',
        'calendar',
        'integration'
      ]));
    }
  }, [selectedToggles]);

  useEffect(() => {
    if (isSales && (location.pathname.includes('deals') || location.pathname.includes('rolodex') || location.pathname.includes('leads'))) {
      navigate('/app/dashboard');
    }
  }, [isSales]);

  if (loading) {
    return <LoaderPage />;
  }

  return (
    <AppTheme {...props}>
      <TwilioProvider>
        <IncomingCallModal />
        <Box display="flex" height="100vh">
          <Box width="100%">
            <HeaderComponent />
            <Outlet />
          </Box>
        </Box>
        <RouteChangeToastCleaner />
        <ErrorModal />
      </TwilioProvider>
    </AppTheme>
  );
};

export default AppPage;
